export default function urlContain(url) {
    let KEYWORD = "usedtractorstorage";
    let SAS_TOKEN = process.env.REACT_APP_AZURE_SAS_TOKEN || "?sv=2025-11-05&ss=b&srt=o&sp=r&se=2029-05-04T22:40:05Z&st=2026-05-04T14:25:05Z&spr=https&sig=ZVSHN7NbH0vYljGTdXEEtcPUxupV0Je3MCtP6U5xEzo%3D";
    return (
        (url?.indexOf(KEYWORD) !== -1) ? `${url}${SAS_TOKEN}` : url
    )
}